(function () {
  const META_PIXEL_ID = '454505980476393';
  const ADD_TO_CART_SOURCES = ['product-form', 'quick-add', 'quick-add-bulk', 'standard-actions-override'];

  function initFbqStub() {
    if (window.fbq) return;

    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });

    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
  }

  function metaEventPayload(variantId, title, value, currency) {
    return {
      content_ids: [String(variantId)],
      content_type: 'product',
      content_name: title,
      value: value,
      currency: currency,
    };
  }

  function trackViewContent() {
    const product = window.__metaProduct;
    if (!product || !window.fbq) return;

    window.fbq(
      'track',
      'ViewContent',
      metaEventPayload(product.variantId, product.title, product.price, product.currency)
    );
  }

  function loadMetaPixel() {
    if (window.norvegrMetaPixelLoaded) return;
    window.norvegrMetaPixelLoaded = true;

    initFbqStub();

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = function () {
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
      trackViewContent();
    };

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  function getAddedItem(event) {
    const cartData = event.cartData;
    const currency = cartData?.currency || window.__metaProduct?.currency;

    if (cartData?.items?.length) {
      const added = cartData.items[cartData.items.length - 1];
      const variantId = added.variant_id || added.id;
      const price = (added.final_price ?? added.price) / 100;
      const quantity = added.quantity || 1;

      return {
        variantId,
        title: added.product_title || added.title,
        price,
        quantity,
        currency,
      };
    }

    if (event.productVariantId && window.__metaProduct) {
      return {
        variantId: event.productVariantId,
        title: window.__metaProduct.title,
        price: window.__metaProduct.price,
        quantity: 1,
        currency: window.__metaProduct.currency,
      };
    }

    return null;
  }

  function trackAddToCart(event) {
    if (!ADD_TO_CART_SOURCES.includes(event.source)) return;

    loadMetaPixel();

    const item = getAddedItem(event);
    if (!item || !window.fbq) return;

    const value = item.price * item.quantity;

    window.fbq(
      'track',
      'AddToCart',
      metaEventPayload(item.variantId, item.title, value, item.currency)
    );
  }

  function initTracking() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, trackAddToCart);
    }
  }

  ['click', 'touchstart', 'keydown'].forEach(function (eventType) {
    window.addEventListener(eventType, loadMetaPixel, { once: true, passive: true });
  });

  window.setTimeout(loadMetaPixel, 45000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }
})();
